module.exports = __webpack_public_path__ + "static/img/lichengImg1.86d64a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/lichengImg1.png
// module id = l9Bo
// module chunks = 2